// extracted by mini-css-extract-plugin
export default {"matchScore":"MatchScore_matchScore__MmUgR","firstTeam":"MatchScore_firstTeam__O3CPh","secondTeam":"MatchScore_secondTeam__+OoTb","score":"MatchScore_score__nVvD-"};